import React, { useEffect, useMemo, useRef, useState } from "react";
import HistoricalDataL1 from "../../components/features/dashboards/dashboardl1/dashboard/HistoricalDataL1";
import FollowupTableL1 from "./../../components/features/dashboards/dashboardl1/dashboard/FollowupTableL1";
import DashFilters from "../../components/features/dashboards/dashboardl1/dashboard/DashFilters";
import PotentialStatusL1 from "../../components/features/dashboards/dashboardl1/dashboard/PotentialStatusL1";
import ProbabilityStatusL1 from "../../components/features/dashboards/dashboardl1/dashboard/ProbabilityStatusL1";
import ConversionRateL1 from "../../components/features/dashboards/dashboardl1/dashboard/ConversionRateL1";
import LeadSourceL1 from "../../components/features/dashboards/dashboardl1/dashboard/LeadSourceL1";
import QuotedMeanL1 from "../../components/features/dashboards/dashboardl1/dashboard/QuotedMeanL1";
import MyRequests from "../Operations/Operationperson/MyRequests";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import Finance from "../finance/Finance";
import { clearScrollTarget } from "../../store/slices/scrollSlice";
import SalesFinaceFilter from "../Operations/SalesOperations/SalesFinance/TableSalesFinance/SalesFinaceFilter";
import SalesProjects from "../Operations/SalesOperations/SaleOperation/SalesParent/SalesProjects";
import ProjectManager from "../Operations/OperationParent/ProjectManager";

const Dashboard = () => {
  const popupRef = useRef(null);
  const [showLogout, setshowlogout] = useState(false);
  const dispatch = useDispatch();
  const { targetComponent } = useSelector((state) => state.scroll);
  const financeRef = useRef(null);
  const projectManagerRef = useRef(null);
  const operationRef = useRef(null);
  const salesOperationsRef = useRef(null);


  const componentRefs = useMemo(
    () => ({
      "Profit and Loss Tracker": financeRef,
      "Project Manager": projectManagerRef,
      "Operations Person": operationRef,
      "Operations Tracker": salesOperationsRef,
    }),
    []
  );

  useEffect(() => {
    if (targetComponent && componentRefs[targetComponent]?.current) {
      let topOffset = 150; // Height of your fixed header in px
      if (targetComponent === "Operations Tracker") {
        topOffset = 10; // 👈 change this number to control scroll distance
      }
      if (targetComponent === "Profit and Loss Tracker") {
        topOffset = 10; // 👈 change this number to control scroll distance
      }
      const element = componentRefs[targetComponent].current;
      const y =
        element.getBoundingClientRect().top + window.scrollY - topOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      dispatch(clearScrollTarget());
    }
  }, [targetComponent, dispatch, componentRefs]);

  useEffect(() => {
    dispatch(setCurrentPageTitle("Dashboard"));
  }, [dispatch]);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  const [userLevel, SetUserLevel] = useState("");
  const [customRole, setcustomRole] = useState([]);
  const { session } = useSelector((state) => state.session);

  useEffect(() => {
    const authLevel = session?.auth || localStorage.getItem("auth");
    const rawRoles = session?.customRoles || localStorage.getItem("Roles");
    const customRoles = Array.isArray(rawRoles)
      ? rawRoles
      : typeof rawRoles === "string"
        ? [rawRoles]
        : [];
    if (authLevel === "L4" && customRoles.length > 0) {
      setcustomRole(customRoles);
    }
    SetUserLevel(authLevel);
  }, [session]);

  const ComponentAccessArray = useMemo(
    () => [
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Dash Filters",
        component: <DashFilters wrapperClasses="w-[100%] " />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Followup Table",
        component: <FollowupTableL1 wrapperClasses="w-full mt-[1rem]" />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Potential Status",
        component: <PotentialStatusL1 wrapperClasses="w-[50%] " />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Probability Status",
        component: <ProbabilityStatusL1 wrapperClasses="w-[50%] " />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Lead Source",
        component: <LeadSourceL1 wrapperClasses="w-[50%]" />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Conversion Rate",
        component: <ConversionRateL1 wrapperClasses="w-[50%]" />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "Historical Data",
        component: <HistoricalDataL1 wrapperClasses="w-[50%]" />,
      },
      {
        roles: ["L0", "L1", "L2", "L3"],
        name: "QuotedMeanL1",
        component: <QuotedMeanL1 wrapperClasses="w-[50%]" />,
      },
    ],
    []
  );

  const ComponentAccessArrayTwo = useMemo(
    () => [
      {
        roles: ["L4", "project manager"],
        name: "Project Manager", //
        component: <ProjectManager />,
      },

      {
        roles: ["L4", "operations"],
        name: "Operations Person",
        component: <MyRequests />,
      },
      {
        roles: ["L0", "L1", "L3"],
        name: "Operations Tracker",
        component: (
          <SalesProjects wrapperClasses="w-[100%]" />
        ),
      },
      {
        roles: ["L0", "L1", "L2"],
        name: "Profit and Loss Tracker",
        component: <Finance ref={financeRef} wrapperClasses="w-[100%]" />,
      },
      {
        roles: ["L3"],
        name: "Profit and Loss Tracker",
        component: <SalesFinaceFilter ref={financeRef} />,
      },
    ],
    []
  );

  return (
    <>
      <div className="dashboard-page w-full flex flex-wrap pb-10">
        <div className="w-full flex flex-wrap">
          {(userLevel === "L4"
            ? ComponentAccessArray.find(
              (c) =>
                c.roles?.includes("L4") &&
                Array.isArray(customRole) &&
                customRole.some((role) => c.roles.includes(role))
            )
              ? [
                ComponentAccessArray.find(
                  (c) =>
                    c.roles?.includes("L4") &&
                    Array.isArray(customRole) &&
                    customRole.some((role) => c.roles.includes(role))
                ),
              ]
              : []
            : ComponentAccessArray.filter((c) => c.roles?.includes(userLevel))
          ).map((c, index) => (
            <React.Fragment key={index}>{c.component}</React.Fragment>
          ))}
        </div>
        <div className="w-full flex flex-wrap">
          {(userLevel === "L4"
            ? ComponentAccessArrayTwo.find(
              (c) =>
                c.roles?.includes("L4") &&
                Array.isArray(customRole) &&
                customRole.some((role) => c.roles.includes(role))
            )
              ? [
                ComponentAccessArrayTwo.find(
                  (c) =>
                    c.roles?.includes("L4") &&
                    Array.isArray(customRole) &&
                    customRole.some((role) => c.roles.includes(role))
                ),
              ]
              : []
            : ComponentAccessArrayTwo.filter((c) =>
              c.roles?.includes(userLevel)
            )
          ).map((c, index) => {
            const ref = componentRefs[c.name] || null;

            return (
              <div key={index} ref={ref} className="w-full">
                {c.component}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
